import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@mui/material/styles';
import { DEFAULT_BACKGROUND_COLOR, WIDGET_STATE, } from '../../common';
import { WriteToUsForm } from '../WriteToUsForm';
import { Chat } from '../Chat';
import { KnowledgeBase } from '../KnowledgeBase';
import { localization } from '../../locales';
import { typedLocalStorage } from '../../utils/typedLocalStorage';
import { WidgetContext } from './services/widgetContext';
import { initHandleFrameMessages } from './services/handleFrameMessages';
import { SocketService } from './services/socketService';
import { getLanguage } from './services/getLanguage';
import { theme } from './defaultMuiTheme';
import * as styles from './App.module.css';
export const App = () => {
    const [currentWidgetState, setCurrentWidgetState] = useState();
    const [widgetSettings, setWidgetSettings] = useState();
    const [api, setApi] = useState();
    const [socketService, setSocketService] = useState();
    const [newUserData, setNewUserData] = useState('');
    const [customSettings, setCustomSettings] = useState({
        isDisabledNameAndEmail: false,
        customFields: [],
    });
    const wrapperRef = useRef(null);
    const widgetBackgroundColor = (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor) || DEFAULT_BACKGROUND_COLOR;
    const lang = getLanguage(widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.language, widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.application);
    const stateComponent = {
        form: _jsx(WriteToUsForm, { isFullForm: (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.blocks.includes('form')) || false }),
        chat: _jsx(Chat, {}),
        knowledge: _jsx(KnowledgeBase, {}),
    };
    useEffect(() => {
        const onFrameMessage = initHandleFrameMessages({
            setWidgetSettings,
            setApi,
            setCurrentWidgetState,
            setSocketService,
            setNewUserData,
            setCustomSettings,
        });
        window.addEventListener('message', onFrameMessage);
        return () => window.removeEventListener('message', onFrameMessage);
    }, []);
    useEffect(() => {
        if (wrapperRef.current) {
            const wrapperElement = wrapperRef.current;
            wrapperElement.style.setProperty('--background', widgetBackgroundColor);
        }
    }, [widgetBackgroundColor]);
    useEffect(() => {
        if (!socketService)
            return;
        const eventListener = { 'join response': () => setCurrentWidgetState(WIDGET_STATE.CHAT) };
        socketService.addEventListener(eventListener);
        return () => socketService.removeEventListener(eventListener);
    }, [socketService]);
    const onRedirectToState = (redirectState) => {
        if (redirectState === WIDGET_STATE.WRITE_TO_US_FORM && (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.blocks.includes('chat'))) {
            const userData = typedLocalStorage === null || typedLocalStorage === void 0 ? void 0 : typedLocalStorage.getItem('userData');
            const joinResponseData = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData;
            if (!userData)
                setCurrentWidgetState(WIDGET_STATE.WRITE_TO_US_FORM);
            if (!joinResponseData && userData)
                socketService === null || socketService === void 0 ? void 0 : socketService.registerChat(JSON.parse(userData));
            if (joinResponseData && userData)
                setCurrentWidgetState(WIDGET_STATE.CHAT);
            return;
        }
        setCurrentWidgetState(redirectState);
    };
    return (_jsx(IntlProvider, { messages: localization[lang], locale: lang, defaultLocale: 'en', children: _jsx(ThemeProvider, { theme: theme, children: _jsx(WidgetContext.Provider, { value: {
                    redirectToState: onRedirectToState,
                    api,
                    widgetSettings,
                    socketService,
                    newUserData,
                    customSettings,
                }, children: _jsx("div", { className: styles.wrapper, ref: wrapperRef, children: currentWidgetState && stateComponent[currentWidgetState] }) }) }) }));
};
export { WidgetContext, SocketService };
